<template>
    <div class="header" id="initiate_header">
        <div class="logo">
            <img src="https://s.moimg.net/dist/img/modian-logo.png" @click="goIndex" />
            <p>项目管理后台</p>
        </div>
        <div class="op">
            <el-button type="primary" @click="goInitiate">发起众筹项目</el-button>
            <!-- 私信 -->
            <div class="icon iconMessage marginL">
              <CompCount />
            </div>
            <!-- 站内信 -->
            <div class="icon iconMessage marginL" style="margin-top: -3px;">
              <el-badge :value="messageNum" :hidden="(messageNum < 1)">
                <div class="icon-information" @click="goMessage"></div>
              </el-badge>
              <div class="tips" v-if="messageNum > 0">{{messageNum}}条未读站内信</div>
              <div class="tips" v-else>站内信</div>
            </div>
            <!-- 头像 -->
            <el-dropdown>
              <div class="avtar marginL" @click="goUserInfo">
                <img :src="$imgUrlFilter( (userDetail.user && userDetail.user.icon) || 'https://s.moimg.net/new/images/headPic.png', 68)">
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>
                    <div class="user-drop" @click="goUserInfo">
                      <span class="icon-my"></span>
                      <span class="name">个人中心</span>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div class="user-drop" @click="goExit">
                      <span class="icon-exit"></span>
                      <span class="name">退出</span>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import domain from '@/service/domain'
import { mapState, mapActions } from 'vuex'
import CompCount from "@@/common/unreadCount.vue"
export default {
  computed: {
    ...mapState({
      userId: state => state.user.user_id,
      userIcon: state => state.user.userIcon,
      userDetail: state => state.user.userDetail,
      hasPop: state => state.user.hasPop,
      messageNum: state => state.message.messageNum,
    })
  },
  components: {
    CompCount
  },
  async created() {
    if (this.userId) {
      // 获取用户标签
      if (this.$route.path.indexOf('/project_manage_full/') > -1) {
        // do nothing
      } else {
         await this.getCpTag()
      }
        this.getMessageUnread()
        await this.getUserDetail()
      
    }
  },
  methods: {
    ...mapActions({
      getMessageUnread: "getMessageUnread",
      getUserDetail: "getUserDetail",
      getCpTag: "getCpTag"
    }),
    goIndex() {
      location.href = domain.www
    },
    goLink(path) {
      if (path) {
        window.open(path)
      }
    },
    goInitiate() {
      window.open(`${domain.account}/initiate`)
    },
    goUserInfo() {
      // window.open(`${domain.www}/user/center`)
      window.open(`${domain.me}/u/user_index`)
    },
    goExit() {
      var hostname=window.location.hostname;
      var arr=hostname.split(".");
      var domain2=arr[arr.length-2]+"."+arr[arr.length-1];
      var aCookie = document.cookie.split(";");
      for (var i = 0; i < aCookie.length; i++) {
          var aCrumb = aCookie[i].split("=");
          var key = aCrumb[0].toString().trim();
          Cookies.remove(key, { path: '/', domain: domain2 })
          // document.cookie = key+'=;expires='+new Date(0)+';domain='+domain2+';path=/';
      }
      window.location.reload()
    },
    goMessage() {
      window.open(`${domain.www}/message/list`)
    },
  }
}
</script>

<style scoped lang="scss">
.header {
    width: 100%;
    min-width: 1080px;
    padding: 0 40px;
    height: 70px;
    box-shadow: 0px 1px 0px 0px #F2F2F2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 2001;
    .logo {
      display: flex;
      align-items: center;
      >img{
        cursor: pointer;
        width: 94px;
        margin-right: 20px;
      }
      p{
        height: 16px;
        line-height: 16px;
        color: #1A1A1A;
        font-size: 16px;
        padding: 0 0 0 20px;
        border-left: 1px solid #DEE0E1;
      }
    }
    .op{
      display: flex;
      align-items: center;
      .avtar{
        width: 30px;
        height: 30px;
        opacity: 1;
        border: 2px solid #DEE0E1;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .icon {
        font-size: 20px;
        cursor: pointer;
        &.iconMessage {
          position: relative;
            .tips {
              white-space: nowrap;
              font-size: 12px;
              border-radius: 2px;
              background-color: #1A1A1A;
              color: #fff;
              line-height: 1;
              padding: 3px 5px 5px;
              position: absolute;
              left: 50%;
              top: 26px;
              transform: translateX(-50%);
              display: none;
            }
            &:hover {
              .tips {
                display: block;
              }
            }
          }
        }
    }
    .marginL {
      margin-left: 40px;
    }
}

.user-drop {
  display: flex;
  align-items: center;
  line-height: 1;
  font-size: 16px;
  padding: 5px 4px;
  .name {
    margin-left: 5px;
  }
}
</style>
